export default __webpack_public_path__ + "static/media/bg-13.c9d83964.jpg";